<p-dialog
  header="Inactive Account"
  [(visible)]="showDialog"
  [closable]="true"
  [dismissableMask]="true"
  [modal]="true"
  (onHide)="hideSignUpDialog()"
  [baseZIndex]="2003"
>
  <div [style]="{ 'margin-top': '2rem' }"></div>
  <div class="p-d-flex p-jc-center">
    <div>
      Contact <a href="mailto:support@technews.io">support@technews.io</a> to activate your subscription.
    </div>
  </div>
</p-dialog>
